let LABELS = {
  'COURSE': 'Course Section',
  'TOC': 'Table Of Contents',
  'SHOW_TOC': 'show TOC',
  'HIDE_TOC': 'hide TOC'
}

export { LABELS }



// WEBPACK FOOTER //
// ./src/labels.js